var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamara({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.574,
    height: 17.066,
    viewBox: "0 0 28.574 17.066",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff;stroke-linecap:round;stroke:#173c6d;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15943",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_8046",
    width: 18.079,
    height: 15.066,
    className: "cls-1",
    rx: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15930",
    transform: "translate(20.246 2.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15929"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15928"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_15191",
    d: "M630.318 481.045l-5.581 3.223a.376.376 0 0 0-.187.323v4.217a.376.376 0 0 0 .187.323l5.581 3.223a.373.373 0 0 0 .56-.323v-10.663a.372.372 0 0 0-.56-.323z",
    className: "cls-1",
    transform: "translate(-624.55 -480.994)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "L\\xEDnea_520",
    fill: "none",
    stroke: "#173c6d",
    strokeMiterlimit: 10,
    strokeWidth: "2px",
    d: "M0 4.647L0 0",
    transform: "translate(.001 3.382)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamara);
export default __webpack_public_path__ + "static/media/camara.8d8d7e832442ca3ea3d8da976e5c6173.svg";
export { ForwardRef as ReactComponent };